"use client";
import React, { useState } from "react";
import Image from "next/image";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  // rohailjohn
  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {/* {text} */}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="updatedparapremu pt-6"
        ></p>
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};
function blackcar({ Mydata }) {
  const data = Mydata[5];
  return (
    <div className="mb-10 ">
      <div className="mx-auto px-6 pt-10 max-w-7xl">
        <div className=" grid grid-cols-5 lg:gap-10">
          <div className="flex-auto col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2">
            <div id="visionh2" className=" md:pt-3 lg:pt-3">
              <Image
                src={data.image}
                height={400}
                width={1200}
                alt={data.alt}
                title={data.tle}
              />
            </div>
          </div>

          <div className="mb-4 col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-3">
            <h2 className="mt-4 text-4xl secondary font-bold">
              <span>{data.title}</span>
              {""}
              <span className="text-[#D5AF34]">{data.subtitle}</span>
            </h2>

            <div className="disy">
              {/* <p
                dangerouslySetInnerHTML={{ __html: data.des }}
                className="updatedparapremu display pt-6"
              ></p> */}
              {/* <p className="updatedparapremu pt-6">{data.des}</p> */}
            </div>

            <div className="">
              <ReadMore maxLines={5}>{data.des}</ReadMore>
            </div>
          </div>

          {/* <div className=" col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-3">
          <h2 id="visionh2" className="text-4xl secondary font-bold">
            <span>{data.title1}</span>{" "}
            <span className="text-[#D5AF34]">{data.subtitle1}</span>
          </h2>

          <div className="">
            <p
              dangerouslySetInnerHTML={{ __html: data.des1 }}
              className="updatedparapremu pt-6"
            ></p>
          </div>
        </div>

        <div className="display  col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2 lg:mt-0 md:mt-5 sm:mt-0 md:flex md:flex-col-reverse">
          <Image src={data.image1} height={400} width={1200} alt={data.alt1} />
        </div> */}
        </div>
        <div
          key={data.name}
          className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center lg:gap-x-8"
        >
          <div className="mt-4 lg:col-span-7 lg:mt-7 xl:col-span-7">
            <h2 className="text-4xl secondary font-bold">
              <span className="text-[#D5AF34]">{data.subtitle1}</span>
              {""}
              <span>{data.title1}</span>{" "}
            </h2>
            <div className="display">
              <p
                dangerouslySetInnerHTML={{ __html: data.des1 }}
                className="updatedparapremu display pt-6"
              ></p>
              {/* <p className="updatedparapremu pt-6">{data.des}</p> */}
            </div>

            <div className="display-desktop">
              <ReadMore maxLines={5}>{data.des1}</ReadMore>
            </div>
          </div>
          <div className="flex-auto col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-5">
            <div id="visionh2" className=" md:pt-3 lg:pt-3">
              <Image
                src={data.image1}
                height={400}
                width={1200}
                alt={data.alt1}
                title={data.tle1}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default blackcar;
